module.exports = __webpack_public_path__ + "images/elipsis6108acffb478b0dbf30d495fc7ec992e.png";